import { useEffect, useRef, useState } from 'react'
import type { BoundingRect } from 'react-measure'
import { transitions } from 'blocks.app/config'
import type { CollapseProps } from './collapse.types'

const CollapseMethods = (p_: CollapseProps) => {
    const [open, setOpen] = useState<boolean>(p_.initialOpen || false)
    const [withoutOverflow, setWithoutOverflow] = useState<boolean>(false)
    const [dimensions, setDimensions] = useState<BoundingRect | null>(null)
    const animationTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

    useEffect(() => {
        return () => {
            if (animationTimer.current) {
                clearTimeout(animationTimer.current)
            }
        }
    }, [])

    const onClick = () => {
        if (!p_.disabled) {
            const _open = !open

            toggleOverflow(_open)
            setOpen(_open)
            p_.onToggle(_open)
        }
        if (p_.onClick) {
            p_.onClick()
        }
    }
    const contentOpen = () => {
        setOpen(true)
    }
    const contentClose = () => {
        setOpen(false)
    }
    const toggleOverflow = (status: boolean) => {
        if (!p_.withoutOverflow) {
            return
        }

        if (status) {
            if (animationTimer.current) {
                clearTimeout(animationTimer.current)
            }
            animationTimer.current = setTimeout(() => {
                setWithoutOverflow(true)
            }, transitions.normal)
        } else {
            if (animationTimer.current) {
                clearTimeout(animationTimer.current)
                animationTimer.current = null
            }
            setWithoutOverflow(false)
        }
    }
    const updateDimensions = (bounds?: BoundingRect) => {
        setDimensions(bounds || null)
    }

    return {
        open,
        withoutOverflow,
        dimensions,
        onClick,
        updateDimensions,
        contentOpen,
        contentClose,
    }
}

export default CollapseMethods
